module.exports = __webpack_public_path__ + "static/media/14pic.85639219.jpg";